import { render, staticRenderFns } from "./HeartFillIcon.vue?vue&type=template&id=396eb8fa&"
import script from "./HeartFillIcon.vue?vue&type=script&lang=js&"
export * from "./HeartFillIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports